/* eslint-disable lingui/no-unlocalized-strings */
import { useSyncExternalStore, useMemo } from 'react'
import { screens } from '@vgw/multibrand-fe-styles'

export const useIsDesktop = () => {
  const query = useMemo(
    () => window.matchMedia(`(min-width: ${screens.lg})`),
    [],
  )

  const subscribe = (callback: () => void) => {
    query.addEventListener('change', callback)
    return () => query.removeEventListener('change', callback)
  }

  const getSnapshot = () => query.matches

  const isDesktop = useSyncExternalStore(subscribe, getSnapshot)

  return { isDesktop }
}
